// powerAvailabilitySeries.ts
import Highcharts from 'highcharts';

import type { TimeseriesMetric } from '@/pcs/domain/entities/pcs-timeseries';

import { baseColors } from '../../color-palette';
import { generateShade } from '../../color-utils';

export const generatePowerAvailabilitySeries = (
  section: TimeseriesMetric,
): Highcharts.SeriesOptionsType[] => {
  const uniqueIds = Array.from(new Set(section.lines.map((line) => line.id)));

  const idToFrontendID: Record<string, string> = {};
  section.lines.forEach((line) => {
    if (!idToFrontendID[line.id]) {
      idToFrontendID[line.id] = line.fullFrontendID;
    }
  });

  const idColorMap: Record<string, string> = {};
  uniqueIds.forEach((id, index) => {
    idColorMap[id] = baseColors[index % baseColors.length];
  });

  const series: Highcharts.SeriesOptionsType[] = [];

  const opacity = 0.8 / uniqueIds.length;

  section.lines.forEach((line) => {
    const okLine = line.subLines.find((s) => s.label === `ok`);
    const invalidLine = line.subLines.find((s) => s.label === `invalid`);

    const gapColor = generateShade(idColorMap[line.id], 'gap');
    const invalidColor = generateShade(idColorMap[line.id], 'invalid');

    // 1) Range
    if (okLine && invalidLine) {
      series.push({
        type: 'area',
        name: `${line.fullFrontendID}  range (${line.idStatus})`,
        data: invalidLine.data.map((p) => [p.timestamp.getTime(), p.value]),
        color: gapColor,
        lineWidth: 0,
        stacking: 'normal',
        stack: `stack-${line.id}`,
        fillOpacity: opacity,
        showInLegend: false,
        marker: {
          enabled: false,
        },
        zIndex: 1,
      });
    }

    // 2) Avg line
    if (okLine) {
      series.push({
        type: 'area',
        name: `${line.fullFrontendID} avg (${line.idStatus})`,
        data: okLine.data.map((p) => [p.timestamp.getTime(), p.value]),
        zIndex: 2,
        stacking: 'normal',
        stack: `stack-${line.id}`,
        color: invalidColor,
        fillOpacity: 0,
        showInLegend: false,
        marker: {
          enabled: true,
          symbol: 'circle',
          radius: 2,
        },
      });
    }
  });

  return series;
};
